interface EmptyStateProps {
  icon: React.ReactNode;
  headline: string;
  subtext: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, headline, subtext, cta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-white/15 py-14 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/5 text-white/40">
        {icon}
      </div>
      <p className="mt-4 text-sm font-semibold text-white">{headline}</p>
      <p className="mt-1 max-w-xs text-sm text-white/50">{subtext}</p>
      {cta && (
        <button
          onClick={cta.onClick}
          className="mt-5 rounded-lg bg-pix-pink px-4 py-2 text-sm font-medium text-white hover:bg-pix-pink-dark"
        >
          {cta.label}
        </button>
      )}
    </div>
  );
}
